import api from './api';

export interface Medication {
  id: number;
  name: string;
  dosage_amount: number | null;
  dosage_unit: string | null;
  freq_amount: number | null;
  freq_period: string | null;
  duration_in_days: number | null;
  category: string | null;
  sub_category: string | null;
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface MedicationCreate {
  name: string;
  dosage_amount?: number | null;
  dosage_unit?: string | null;
  freq_amount?: number | null;
  freq_period?: string | null;
  duration_in_days?: number | null;
  category?: string | null;
  sub_category?: string | null;
  tenant_id?: number;
}

export interface MedicationUpdate {
  name?: string;
  dosage_amount?: number | null;
  dosage_unit?: string | null;
  freq_amount?: number | null;
  freq_period?: string | null;
  duration_in_days?: number | null;
  category?: string | null;
  sub_category?: string | null;
}

export const medicationService = {
  async getMedications(tenantId?: number): Promise<Medication[]> {
    const params = tenantId ? `?tenant_id=${tenantId}` : '';
    const response = await api.get(`/medications/${params}`);
    return response.data;
  },

  async getMedication(medicationId: number): Promise<Medication> {
    const response = await api.get(`/medications/${medicationId}`);
    return response.data;
  },

  async createMedication(medicationData: MedicationCreate): Promise<Medication> {
    const response = await api.post('/medications/', medicationData);
    return response.data;
  },

  async updateMedication(medicationId: number, medicationData: MedicationUpdate): Promise<Medication> {
    const response = await api.put(`/medications/${medicationId}`, medicationData);
    return response.data;
  },

  async deleteMedication(medicationId: number): Promise<void> {
    await api.delete(`/medications/${medicationId}`);
  },
};
